import { useEffect, useState } from 'react';
import { TableCell } from '@mui/material';

const PriceCell = ({ previousSize, currentSize, isDecimal, isFontWeight, isQty, backgroundColor }) => {
    const [bgColor, setBgColor] = useState(backgroundColor);
    const [fontColor, setColor] = useState('black');

    useEffect(() => {
        if (previousSize == null || currentSize == null) return;

        if (previousSize < currentSize) {
            if (!isQty)
                setBgColor('green');
            else
                setBgColor('blue');
            setColor('white');
        } else if (previousSize > currentSize) {
            if (!isQty)
                setBgColor('green');
            else
                setBgColor('blue');
            setColor('white');
        }

        const timeout = setTimeout(() => {
            setBgColor(backgroundColor);
            setColor('black');
        }, 1000);

        return () => clearTimeout(timeout);
    }, [previousSize, currentSize, isQty, backgroundColor]);

    const formatNumber = (value) => {
        if (value == null || isNaN(value)) return '-';

        const [integerPart, decimalPart = ''] = value.toString().split('.');
        const withThousands = Number(integerPart).toLocaleString('de-DE');

        let formattedDecimals;
        if (decimalPart.length === 0) {
            formattedDecimals = '00';
        } else if (decimalPart.length === 1) {
            formattedDecimals = `${decimalPart}0`;
        } else {
            formattedDecimals = decimalPart;
        }

        if (!isDecimal) {
            return `${withThousands}`;
        } else {
            return `${withThousands},${formattedDecimals}`;
        }
    };

    return (
        <TableCell style={{ fontVariantNumeric: 'tabular-nums', textAlign: 'right', backgroundColor: bgColor, color: fontColor, fontWeight: isFontWeight ? "bold" : "" }}>
            {formatNumber(currentSize)}
        </TableCell>
    );
};

export default PriceCell;